import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

const AMBIENTE = process.env.REACT_APP_AMBIENTE;

function iniciais(nome) {
  const partes = (nome || '').trim().split(/\s+/).filter(Boolean);
  if (partes.length === 0) return '?';
  const ultima = partes.length > 1 ? partes[partes.length - 1][0] : '';
  return (partes[0][0] + ultima).toUpperCase();
}

const Navbar = () => {
  const { authenticated, userInfo, isAdmin, logout } = useAuth();

  if (!authenticated) {
    return null;
  }

  const nome = userInfo?.name || userInfo?.email || 'Usuário';
  const links = [['/dashboard', 'Cálculo']];
  if (isAdmin) {
    links.push(['/admin', 'Acesso ao Dashboard'], ['/admin/cortesias', 'Cortesias']);
  }

  return (
    <header className="mp-header">
      <div className="mp-header-inner">
        <Link className="mp-brand" to="/dashboard" aria-label="MagisPrev, dashboard">
          <img src="/magisprev-icon.png" width="36" height="36" alt="" />
          <span>MAGISPREV</span>
          <small>Dashboard</small>
        </Link>

        {AMBIENTE && <span className="mp-env">{AMBIENTE}</span>}

        <nav className="mp-nav" aria-label="Navegação principal">
          {links.map(([to, rotulo]) => (
            <NavLink key={to} to={to} end className={({ isActive }) => `mp-nav-link${isActive ? ' active' : ''}`}>
              {rotulo}
            </NavLink>
          ))}
        </nav>

        <div className="dropdown mp-profile">
          <button className="mp-profile-button" data-bs-toggle="dropdown" aria-expanded="false">
            <span className="mp-avatar" aria-hidden="true">{iniciais(nome)}</span>
            <span className="mp-profile-name">
              {nome}
              {isAdmin && <small>Administrador</small>}
            </span>
          </button>
          <ul className="dropdown-menu dropdown-menu-end">
            <li><span className="dropdown-item-text small text-body-secondary">{userInfo?.email}</span></li>
            <li><hr className="dropdown-divider" /></li>
            <li><button className="dropdown-item" onClick={logout}>Sair</button></li>
          </ul>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
